import { Typography } from 'antd';

export const WizardDescription = ({ children, ...props }) => {
  return (
    <Typography.Paragraph className='wizard-description' {...props}>
      {children}
    </Typography.Paragraph>
  );
};
